import _createClass from "/codebuild/output/src850585749/src/natashamanger.com/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/codebuild/output/src850585749/src/natashamanger.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/codebuild/output/src850585749/src/natashamanger.com/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src850585749/src/natashamanger.com/node_modules/@babel/runtime/helpers/esm/createSuper";
import { ValueWithRandom } from "../../ValueWithRandom";
export var SplitFactor = /*#__PURE__*/function (_ValueWithRandom) {
  _inherits(SplitFactor, _ValueWithRandom);
  var _super = _createSuper(SplitFactor);
  function SplitFactor() {
    var _this;
    _classCallCheck(this, SplitFactor);
    _this = _super.call(this);
    _this.value = 3;
    return _this;
  }
  return _createClass(SplitFactor);
}(ValueWithRandom);